// organisms
import MainNavigation from '../components/organisms/main-navigation/main-navigation';
import MobileNavigation from '../components/organisms/mobile-navigation/mobile-navigation';

// molecule
import Hero from '../components/molecule/hero/hero';
import ImageSlider from '../components/molecule/image-slider/image-slider';

// atoms

const dict = new Map(
    [
            ['Hero', Hero],
            ['MainNavigation', MainNavigation],
            ['MobileNavigation', MobileNavigation],
            ['ImageSlider', ImageSlider],
        ]
);

document.querySelectorAll('[data-component]').forEach( (el) => {
    const className = el.dataset.component;

    if(dict.get(className) == undefined) {
        throw new Error(`Component ${className} not found`);
    }
    new (dict.get(className))(el);
});